import type { SaveData } from './GameState';
import { serializeSlotData } from './utils/saveSlots';

export const DEMO_SLOT_INDEX = 4;

const DEMO_SLOT_NAME = 'Demo Save';

const DEMO_SAVE_STRING = `{
    "name": "Save 1",
    "timestamp": 1760237402576,
    "saveData": {
        "version": "1.1",
        "timestamp": 1760237402576,
        "playerPos": {
            "x": 497,
            "y": 501
        },
        "playerInventory": [
            {
                "itemType": "copper-ore",
                "count": 7
            },
            {
                "itemType": "copper-plate",
                "count": 8
            },
            {
                "itemType": null,
                "count": 0
            },
            {
                "itemType": "sand",
                "count": 6
            },
            {
                "itemType": null,
                "count": 0
            },
            {
                "itemType": null,
                "count": 0
            },
            {
                "itemType": "iron-ore",
                "count": 49
            },
            {
                "itemType": null,
                "count": 0
            },
            {
                "itemType": "gear",
                "count": 40
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": "gear",
                "count": 50
            },
            {
                "itemType": null,
                "count": 0
            },
            {
                "itemType": null,
                "count": 0
            }
        ],
        "gameMap": {},
        "buildingLayer": {
            "500,502": "A",
            "491,502": "⚒",
            "492,502": "→",
            "494,502": "→",
            "495,502": "→",
            "496,502": "+",
            "497,502": "→",
            "498,502": "→",
            "502,502": "→",
            "503,502": "→",
            "508,500": "A",
            "504,501": "↑",
            "504,500": "→",
            "505,500": "→",
            "506,500": "→",
            "508,495": "A",
            "511,491": "⚒",
            "510,491": "←",
            "509,491": "←",
            "508,491": "↓",
            "508,492": "+",
            "508,493": "↓",
            "508,497": "↓",
            "510,500": "→",
            "511,500": "→",
            "512,500": "→",
            "513,500": "↓",
            "513,501": "↓",
            "513,502": "↓",
            "513,503": "↓",
            "521,499": "S",
            "522,498": "S",
            "523,498": "S",
            "524,499": "S",
            "524,505": "S",
            "513,504": "→",
            "514,504": "→",
            "508,498": "↓",
            "516,504": "→",
            "517,504": "→",
            "518,504": "→",
            "519,504": "↓",
            "519,505": "↓",
            "519,506": "↓",
            "519,507": "↓",
            "519,509": "R",
            "505,502": "↓",
            "505,503": "↓",
            "504,509": "A",
            "505,505": "←",
            "504,505": "↓",
            "504,506": "↓",
            "504,507": "↓",
            "506,509": "→",
            "507,509": "→",
            "508,509": "→",
            "509,509": "→",
            "511,509": "→",
            "513,509": "→",
            "514,509": "→",
            "515,509": "→",
            "516,509": "→",
            "517,509": "→",
            "504,502": "+",
            "495,486": "⚒",
            "495,487": "↓",
            "495,488": "↓",
            "495,489": "↓",
            "495,490": "↓",
            "495,491": "→",
            "496,491": "→",
            "497,491": "→",
            "498,491": "→",
            "499,491": "→",
            "500,491": "→",
            "501,491": "→",
            "502,491": "→",
            "503,491": "→",
            "504,491": "→",
            "505,491": "→",
            "506,491": "→",
            "507,491": "→",
            "514,495": "A",
            "509,492": "→",
            "510,492": "→",
            "511,492": "→",
            "512,492": "→",
            "513,492": "→",
            "514,492": "↓",
            "514,493": "↓",
            "514,497": "↓",
            "513,497": "←",
            "512,497": "←",
            "511,497": "←",
            "510,497": "←",
            "509,497": "←",
            "514,498": "←",
            "513,498": "↑",
            "487,499": "⚒",
            "488,499": "→",
            "489,499": "→",
            "490,499": "→",
            "493,499": "↑",
            "493,498": "↑",
            "495,495": "→",
            "496,495": "→",
            "497,495": "→",
            "498,495": "→",
            "499,495": "→",
            "500,495": "→",
            "501,495": "→",
            "502,495": "→",
            "503,495": "↓",
            "503,496": "↓",
            "503,497": "↓",
            "503,498": "↓",
            "503,499": "↓",
            "503,500": "↓",
            "503,501": "↓",
            "500,515": "A",
            "496,503": "⇓",
            "496,504": "⇒",
            "497,504": "⇒",
            "498,504": "⇓",
            "498,505": "⇓",
            "498,506": "⇓",
            "498,507": "⇓",
            "498,508": "⇓",
            "498,509": "⇓",
            "498,510": "⇓",
            "498,511": "⇓",
            "498,512": "⇓",
            "498,513": "⇐",
            "497,513": "⇐",
            "496,513": "⇓",
            "496,514": "⇓",
            "496,515": "⇒",
            "497,515": "⇒",
            "498,515": "⇒",
            "501,512": "⇑",
            "501,511": "⇑",
            "501,510": "⇑",
            "501,509": "⇒",
            "502,509": "⇒",
            "501,513": "↑",
            "521,495": "G",
            "522,497": "G",
            "522,501": "G",
            "523,500": "G",
            "524,502": "G",
            "510,509": "+",
            "510,510": "↓",
            "510,511": "↓",
            "510,512": "☐",
            "505,504": "+",
            "506,504": "→",
            "507,504": "→",
            "508,504": "↓",
            "508,505": "↓",
            "508,506": "↓",
            "508,507": "→",
            "509,507": "→",
            "510,507": "→",
            "512,507": "→",
            "513,507": "↓",
            "513,508": "→",
            "514,508": "→",
            "515,508": "→",
            "516,508": "→",
            "517,508": "→",
            "512,517": "≈",
            "516,517": "≈",
            "512,518": "→",
            "513,518": "→",
            "514,518": "→",
            "516,518": "→",
            "517,518": "→",
            "518,518": "→",
            "515,521": "A",
            "520,521": "A",
            "519,516": "↑",
            "519,515": "↑",
            "519,514": "↑",
            "519,513": "↑",
            "519,512": "↑",
            "519,511": "↑",
            "504,504": "←",
            "503,504": "←",
            "502,504": "↓",
            "502,505": "↓",
            "502,506": "☐",
            "513,512": "↑",
            "513,511": "↑",
            "513,510": "→",
            "514,510": "→",
            "515,510": "→",
            "516,510": "→",
            "517,510": "→",
            "510,513": "↓",
            "510,514": "→",
            "511,514": "→",
            "512,514": "→",
            "513,514": "↑",
            "513,513": "↑",
            "512,509": "→",
            "526,502": "G",
            "527,502": "G",
            "528,502": "G",
            "529,502": "G",
            "530,502": "G",
            "515,517": "≈",
            "514,517": "≈",
            "513,517": "≈",
            "491,499": "☐",
            "493,502": "☐",
            "492,499": "→",
            "511,507": "☐",
            "515,504": "☐",
            "487,494": "A",
            "487,490": "A",
            "487,486": "A",
            "482,494": "+",
            "482,490": "+",
            "482,486": "+",
            "482,496": "↑",
            "482,495": "↑",
            "483,494": "→",
            "484,494": "→",
            "485,494": "→",
            "482,493": "↑",
            "482,492": "↑",
            "482,491": "↑",
            "482,489": "↑",
            "482,488": "↑",
            "482,487": "↑",
            "483,486": "→",
            "484,486": "→",
            "485,486": "→",
            "489,486": "→",
            "490,486": "↓",
            "490,487": "↓",
            "490,488": "↓",
            "490,489": "↓",
            "489,490": "→",
            "490,490": "↓",
            "490,491": "↓",
            "490,492": "↓",
            "490,493": "↓",
            "490,494": "↓",
            "489,494": "→",
            "490,495": "→",
            "493,497": "←",
            "492,497": "←",
            "491,497": "←",
            "490,497": "←",
            "489,497": "←",
            "488,497": "←",
            "487,497": "←",
            "486,497": "←",
            "485,497": "←",
            "484,497": "←",
            "483,497": "←",
            "482,497": "↑",
            "491,495": "→",
            "492,495": "→",
            "493,495": "→",
            "494,495": "→",
            "483,490": "→",
            "484,490": "→",
            "485,490": "→",
            "524,521": "A",
            "528,521": "A",
            "515,518": "+",
            "520,518": "+",
            "524,518": "+",
            "528,518": "+",
            "519,518": "→",
            "521,518": "→",
            "522,518": "→",
            "523,518": "→",
            "525,518": "→",
            "526,518": "→",
            "527,518": "→",
            "528,517": "↑",
            "528,516": "←",
            "526,516": "←",
            "527,516": "←",
            "525,516": "←",
            "524,516": "←",
            "523,516": "←",
            "522,516": "←",
            "521,516": "←",
            "520,516": "←",
            "515,519": "↓",
            "520,519": "↓",
            "524,519": "↓",
            "528,519": "↓",
            "515,523": "↓",
            "515,524": "↓",
            "520,523": "↓",
            "520,524": "↓",
            "524,523": "↓",
            "524,524": "↓",
            "528,523": "↓",
            "528,524": "↓"
        },
        "beltContentLayer": {
            "498,515": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_2251_1760138251052_4pkj3stfr"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_2399_1760138253519_2gcfapbtv"
                }
            ],
            "497,515": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_3540_1760138725755_pu31y4gfa"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_3660_1760138727755_s2jxpu110"
                }
            ],
            "496,515": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_3720_1760138728755_3n6cp8j76"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_3840_1760138730755_kuef98hca"
                }
            ],
            "496,514": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_3900_1760138731754_bagx70qzm"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4020_1760138733755_evbnnvfg5"
                }
            ],
            "496,513": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4080_1760138734755_5mn8ocrqn"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4200_1760138742821_sxgi8ir7i"
                }
            ],
            "497,513": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4260_1760138743821_2rfl1sy1v"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4380_1760138745822_wu358op7q"
                }
            ],
            "498,513": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4440_1760138746821_i60i6p50j"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4560_1760138748822_c0gi17n28"
                }
            ],
            "498,512": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4620_1760138749821_d84yuwj68"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4740_1760138751822_ieafw1vhy"
                }
            ],
            "498,511": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4800_1760138752821_xdusyxy7z"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4920_1760138857355_ewlq1rxnd"
                }
            ],
            "498,510": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_4980_1760138858355_ibuc3wnkp"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5100_1760138860355_6gv6cledu"
                }
            ],
            "498,509": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5160_1760138861355_1bdixi8lj"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5280_1760138863355_thyjg65su"
                }
            ],
            "498,508": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5340_1760138864355_3z51c1ci2"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5460_1760138963723_rbjj71gq8"
                }
            ],
            "498,507": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5520_1760138964722_j9nor41fk"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5640_1760138966722_b3anzmtwn"
                }
            ],
            "498,506": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5700_1760138967721_di5uhwlty"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5820_1760138969721_rjdey98s8"
                }
            ],
            "498,505": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_5880_1760138970724_26qixsrx0"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6000_1760138972722_bz207sor2"
                }
            ],
            "498,504": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6060_1760138973728_clb7vzcc1"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6180_1760138975723_364ric0dx"
                }
            ],
            "497,504": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6240_1760138976722_23c42iz99"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6360_1760138978722_nalsrr5j1"
                }
            ],
            "496,504": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6420_1760139082288_l2b4noaof"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_6540_1760139084288_91oboa32z"
                }
            ],
            "496,503": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_17_1760139085705_s2hqm1e3s"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_137_1760139087705_69p0x9tc7"
                }
            ],
            "498,502": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_afdm7bens"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.7162753680859552,
                    "id": "item_24905_1760237400930_rv96qscbi"
                }
            ],
            "497,502": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_dqm0aa5wy"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.7162753680859552,
                    "id": "item_24905_1760237400930_g3oc2wn9w"
                }
            ],
            "495,502": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_jctow896x"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.7162753680859552,
                    "id": "item_24905_1760237400930_ib5h56oez"
                }
            ],
            "494,502": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24781_1760237397116_tixmzjdsd"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.7162753680859552,
                    "id": "item_24906_1760237400953_vh7voh002"
                }
            ],
            "492,502": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24952_1760237402250_uixaw8ohm"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24962_1760237402509_kuky1m99s"
                }
            ],
            "514,493": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_ha4pi1cse"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_v3zd32w4y"
                }
            ],
            "514,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_y0ccgiqdg"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_58ds4izuy"
                }
            ],
            "513,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_2ueutnk4i"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_ovhktfnlk"
                }
            ],
            "512,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_eoacx9emn"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_2k6mgcj74"
                }
            ],
            "511,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_cppuaecab"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_5w5xmwgt6"
                }
            ],
            "510,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397090_2y6k8mzu8"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_b7bu1qa8t"
                }
            ],
            "509,492": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_yb1awtbe0"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_fz7rfg3t4"
                }
            ],
            "508,493": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_z4ncps5pv"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_5k4p6rix2"
                }
            ],
            "508,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_qnel4stif"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_a1hymkibi"
                }
            ],
            "507,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_cr0ekdm6w"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_ygkwy1fiu"
                }
            ],
            "506,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_gudy34nw1"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_7kritab9s"
                }
            ],
            "505,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_k9z3z1pwd"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_gyfftpn5u"
                }
            ],
            "504,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_5qm2dgkn3"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_xliewl1zl"
                }
            ],
            "503,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_3g0zmbdli"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_807mto2ba"
                }
            ],
            "502,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_b0ldet5oz"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_2dk07q4kp"
                }
            ],
            "501,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_5u61wpdwb"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_uj305e65b"
                }
            ],
            "500,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_x4cdlbtbo"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_rco7j6dhy"
                }
            ],
            "499,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_8q1xnp0td"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_ugmgbglxb"
                }
            ],
            "498,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_n4d3z986e"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_i8z78td2d"
                }
            ],
            "497,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_i1aobd0wy"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_5i9tpx2h6"
                }
            ],
            "496,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_fczss9154"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_33hki4h2r"
                }
            ],
            "495,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_i3mhdth2p"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_n98qc4u0w"
                }
            ],
            "495,490": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_mf8uv43lh"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_gc7yz4i7j"
                }
            ],
            "495,489": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_f7swmo4qg"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_gbv6mocw0"
                }
            ],
            "495,488": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_c6n3pdakq"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_pbcfa2mdj"
                }
            ],
            "495,487": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_24781_1760237397116_7059gupho"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24901_1760237400800_n9dg24ypo"
                }
            ],
            "485,486": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_kcd81zf30"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400764_1awr4k94z"
                }
            ],
            "484,486": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_0pirggsm6"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_k46glcik4"
                }
            ],
            "483,486": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_o7lihf57q"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_uccqzlhq2"
                }
            ],
            "482,487": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_fl41y7suu"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_4pk8jrd7h"
                }
            ],
            "482,488": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_epyslltff"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_inth3sx7a"
                }
            ],
            "482,489": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_45cwxun4r"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_h72iqcy3u"
                }
            ],
            "485,490": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_gv6ctdh3p"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_279t7hlz2"
                }
            ],
            "484,490": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_hpdwyo5rj"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_d13cusnw0"
                }
            ],
            "483,490": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_4f8k9f9em"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_v8rwj0sde"
                }
            ],
            "482,491": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_yn00rmfi4"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_tw7smhcuo"
                }
            ],
            "482,492": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_10t6zs1a9"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_wcomu4rzc"
                }
            ],
            "482,493": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_vqfgkleqq"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_unffp32eg"
                }
            ],
            "485,494": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_hddk8lyxy"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_t99eyja1c"
                }
            ],
            "484,494": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_uqc1ag4kl"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_vx0wxgjy2"
                }
            ],
            "483,494": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_f5c574oim"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_xv121rjxr"
                }
            ],
            "482,495": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_7dsf26sk8"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_h8hj8ymz2"
                }
            ],
            "482,496": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_02mnx2dse"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_bjghnlyp4"
                }
            ],
            "482,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24780_1760237397091_0xurixel3"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_eiih8gatc"
                }
            ],
            "483,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24810_1760237397866_luoa46a21"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400765_31nd3otpm"
                }
            ],
            "484,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.99,
                    "id": "item_24868_1760237399734_52cwrcznt"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.2984480700358149,
                    "id": "item_24940_1760237401901_l4dkyr9hm"
                }
            ],
            "485,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.4536410664544384,
                    "id": "item_24927_1760237401477_1jgugv81g"
                }
            ],
            "486,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401168_eqirxrfkq"
                }
            ],
            "487,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.7401512136888203,
                    "id": "item_24903_1760237400875_r04o6bdde"
                }
            ],
            "488,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.8953442101074438,
                    "id": "item_24890_1760237400398_hl1mop3ji"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_ew1q07g9a"
                }
            ],
            "489,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.20294468762435422,
                    "id": "item_24948_1760237402143_kiw88q2xl"
                }
            ],
            "490,497": [],
            "491,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_sd6tam5zl"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_1jn2mhd7v"
                }
            ],
            "492,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_prpigfllv"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_b8a7dycj4"
                }
            ],
            "493,497": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_zv0p0rcjs"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_yi7mppmvt"
                }
            ],
            "493,498": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_d1d3p5wks"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_hb37c6au9"
                }
            ],
            "493,499": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402227_2srfzcq1h"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402499_fkye8vuk0"
                }
            ],
            "490,499": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_3v4339aq1"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_2bap2x9cs"
                }
            ],
            "489,499": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24951_1760237402225_g0qk2qq4o"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_i3mqaiwux"
                }
            ],
            "488,499": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24952_1760237402250_wqglll5xx"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24962_1760237402509_jut1ch98m"
                }
            ],
            "508,498": [
                {
                    "item": "copper-plate",
                    "progress": 0.05968961400716299,
                    "id": "item_24960_1760237402490_9gq41a6n1"
                }
            ],
            "508,497": [
                {
                    "item": "copper-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1210"
                }
            ],
            "509,497": [
                {
                    "item": "copper-plate",
                    "progress": 0.6327099084759271,
                    "id": "item_24912_1760237401097_54tumhktd"
                }
            ],
            "510,497": [
                {
                    "item": "copper-plate",
                    "progress": 0.20294468762435422,
                    "id": "item_24948_1760237402143_x7qltn55t"
                }
            ],
            "511,497": [],
            "512,497": [
                {
                    "item": "copper-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1211"
                }
            ],
            "509,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_2666_1760147648930_0u11le995"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_3110_1760147656645_ma8b6bf7p"
                }
            ],
            "510,491": [
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_2667_1760147648947_f2se7udw7"
                },
                {
                    "item": "copper-ore",
                    "progress": 0.99,
                    "id": "item_3111_1760147656663_8pfkfgli0"
                }
            ],
            "517,508": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_azcy0pskj"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_88ta2uz9g"
                }
            ],
            "516,508": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_c7yrjc5la"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_s8tt1z5ec"
                }
            ],
            "515,508": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_zx8h8gnu7"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_vfscjpb83"
                }
            ],
            "514,508": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9169_1760139869658_42896zzsg"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9202_1760139870208_umijdmfz9"
                }
            ],
            "513,508": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9218_1760139870475_xix7kh9ps"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9290_1760139871675_iqtis5yaa"
                }
            ],
            "513,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9306_1760139871942_43yuyksp4"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9378_1760139873141_wr7e5xwi8"
                }
            ],
            "512,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9394_1760139873407_cgwwxcngt"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_9466_1760139874608_i94fcfawj"
                }
            ],
            "510,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11170_1760147869283_x0n5und18"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11187_1760147869632_t4ghkflf2"
                }
            ],
            "509,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11198_1760147869860_dywnoj0fx"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11215_1760147870209_7cnf37rwy"
                }
            ],
            "504,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_8qj6zbh8x"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_kleayzcw4"
                }
            ],
            "504,506": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_jn4edqrjn"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_qbqtamlgy"
                }
            ],
            "504,505": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_gf5t2gi5a"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_ffn8209mo"
                }
            ],
            "505,505": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_7tkkc5nav"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_unpe4lb3p"
                }
            ],
            "508,507": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11198_1760147869860_i2oocnxf0"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11215_1760147870209_j4fhk5h91"
                }
            ],
            "508,506": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11226_1760147870434_wppv8kdnl"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11243_1760147870776_xnxyh6fl4"
                }
            ],
            "508,505": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11226_1760147870434_17mujsn4b"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11243_1760147870776_8isbxvl2l"
                }
            ],
            "508,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11254_1760147871015_ptl71lx1k"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11271_1760147871362_txpc86zh2"
                }
            ],
            "507,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11254_1760147871015_3nbcm3dy8"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11271_1760147871362_fgbdi4a2f"
                }
            ],
            "502,505": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18147_1760148022385_0csegfgtn"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18181_1760148023183_3yjbazsq2"
                }
            ],
            "502,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18147_1760148022385_hljj9absi"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18181_1760148023183_wdx5jq98z"
                }
            ],
            "503,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18181_1760148023183_o2d290w2b"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18187_1760148023309_s5q7sgee0"
                }
            ],
            "504,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18181_1760148023183_3wo2azis6"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_18187_1760148023309_qfqqgfhsp"
                }
            ],
            "506,504": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11282_1760147871587_rtbv6m9kr"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_11299_1760147871931_xeo7s30w6"
                }
            ],
            "505,503": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_zwf94aogm"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_8b3qx2zmu"
                }
            ],
            "505,502": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_ess5w9r2m"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400902_m72lbnjpe"
                }
            ],
            "506,500": [
                {
                    "item": "iron-plate",
                    "progress": 0.47751691205730357,
                    "id": "item_24925_1760237401424_3hvslsuqz"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.19100676482292162,
                    "id": "item_24949_1760237402171_xjf28qjap"
                }
            ],
            "505,500": [
                {
                    "item": "iron-plate",
                    "progress": 0.47751691205730357,
                    "id": "item_24925_1760237401424_a3xgtxp1a"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.19100676482292162,
                    "id": "item_24949_1760237402171_9350wa0p4"
                }
            ],
            "504,500": [
                {
                    "item": "iron-plate",
                    "progress": 0.47751691205730357,
                    "id": "item_24925_1760237401424_en1r8tvs3"
                }
            ],
            "504,501": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_11m6chakg"
                }
            ],
            "503,502": [
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_zf8ydu0lz"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1760237400903_vtqft0ppx"
                }
            ],
            "503,501": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24826_1760237398442_hop91fj4d"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_pfpqk12w2"
                }
            ],
            "503,500": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24826_1760237398442_ihfkpwz8p"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_9wyaz4fre"
                }
            ],
            "503,499": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24832_1760237398692_ekogr8ma5"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_k700rxhc1"
                }
            ],
            "503,498": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24860_1760237399506_enspxp0x9"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.8356545961002809,
                    "id": "item_24895_1760237400581_w2xlfmggg"
                }
            ],
            "503,497": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24860_1760237399506_3fyx9cg6w"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.5491444488658991,
                    "id": "item_24919_1760237401266_5563kdznr"
                }
            ],
            "503,496": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24866_1760237399647_vieau8lpr"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.5491444488658991,
                    "id": "item_24919_1760237401266_vrlrhepa4"
                }
            ],
            "503,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.8475925189017135,
                    "id": "item_24894_1760237400542_3v97qlfz1"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.48945483485873614,
                    "id": "item_24924_1760237401396_eg8eksuwa"
                }
            ],
            "502,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.8475925189017135,
                    "id": "item_24894_1760237400542_yfg565afl"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.1551929964186238,
                    "id": "item_24952_1760237402252_99flcqdwq"
                }
            ],
            "501,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1760237400766_offs2obmk"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.1551929964186238,
                    "id": "item_24952_1760237402252_8szdqw4zb"
                }
            ],
            "500,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.4536410664544384,
                    "id": "item_24927_1760237401477_q5w98ywyg"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.08356545961002818,
                    "id": "item_24958_1760237402436_0h9xrmv5a"
                }
            ],
            "499,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.4536410664544384,
                    "id": "item_24927_1760237401477_ynrf6kpon"
                }
            ],
            "498,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.7401512136888203,
                    "id": "item_24903_1760237400876_be3ogw6qp"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.38201352964584295,
                    "id": "item_24933_1760237401684_r6c9xuk74"
                }
            ],
            "497,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.7401512136888203,
                    "id": "item_24903_1760237400876_q12m4qk1h"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.04775169120573039,
                    "id": "item_24961_1760237402498_j02j567re"
                }
            ],
            "496,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_fa63bxyux"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402540_2i4lqwnhm"
                }
            ],
            "495,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.3461997612415452,
                    "id": "item_24936_1760237401788_zopwormd4"
                }
            ],
            "510,511": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401169_g0i2coyhp"
                }
            ],
            "510,510": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401169_ydpylifrb"
                }
            ],
            "517,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12520_1760147898505_k438vornf"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12608_1760147900842_8mphu4yn5"
                }
            ],
            "516,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12608_1760147900842_jgygc38nu"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12696_1760147902917_6uk7s4vys"
                }
            ],
            "515,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12696_1760147902917_ivrg0zcnc"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12784_1760147904610_aazhwlt7y"
                }
            ],
            "514,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12784_1760147904610_pr0m9awqq"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12872_1760147906473_0it4i5juh"
                }
            ],
            "513,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12872_1760147906473_36mxj3n11"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12960_1760147908291_3v02ttlqy"
                }
            ],
            "512,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12960_1760147908291_zgx2atm76"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13048_1760147910109_w5o7dtvv7"
                }
            ],
            "511,509": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13048_1760147910109_sg6ojuisc"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13136_1760147911971_xyhx5m72x"
                }
            ],
            "509,509": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401169_rys2ovutx"
                }
            ],
            "508,509": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401169_dix7m2fzd"
                }
            ],
            "507,509": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1760237401169_tewdbebqp"
                }
            ],
            "506,509": [
                {
                    "item": "gear",
                    "progress": 0.5968961400716294,
                    "id": "item_24915_1216"
                }
            ],
            "513,497": [],
            "513,498": [],
            "514,498": [],
            "514,497": [],
            "519,507": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_kup36aghp"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_tcxeidaz7"
                }
            ],
            "519,506": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_75fuv6fdx"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_kdc2an7wg"
                }
            ],
            "519,505": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_v16gpibsn"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_jesflk198"
                }
            ],
            "519,504": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_fzpdjrjjc"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_b90m301io"
                }
            ],
            "518,504": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_knwjymhlf"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_0vx389313"
                }
            ],
            "517,504": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24908_1760237401001_gjfjoe0ei"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24909_1760237401028_an8mm6000"
                }
            ],
            "516,504": [
                {
                    "item": "circuit",
                    "progress": 0.6804615996816574,
                    "id": "item_24909_1760237401027_jlrzzhri5"
                },
                {
                    "item": "circuit",
                    "progress": 0.6685236768802248,
                    "id": "item_24910_1760237401050_e2pd88e7o"
                }
            ],
            "514,504": [
                {
                    "item": "circuit",
                    "progress": 0.9311579785117415,
                    "id": "item_24887_1760237400306_2a7p1d98m"
                },
                {
                    "item": "circuit",
                    "progress": 0.5133306804616014,
                    "id": "item_24922_1760237401342_5lc2hpdjv"
                }
            ],
            "513,504": [
                {
                    "item": "circuit",
                    "progress": 0.8714683645045787,
                    "id": "item_24892_1760237400470_a6k4sj4fx"
                },
                {
                    "item": "circuit",
                    "progress": 0.4178272980501407,
                    "id": "item_24930_1760237401573_6vhx4dymr"
                }
            ],
            "513,503": [],
            "513,502": [
                {
                    "item": "circuit",
                    "progress": 0.7879029048945506,
                    "id": "item_24899_1760237400732_07wh9ic1g"
                },
                {
                    "item": "circuit",
                    "progress": 0.5610823716673317,
                    "id": "item_24918_1760237401242_ovg31ymn9"
                }
            ],
            "513,501": [
                {
                    "item": "circuit",
                    "progress": 0.2506963788300846,
                    "id": "item_24944_1760237402025_q4jr743fi"
                },
                {
                    "item": "circuit",
                    "progress": 0.011937922801432597,
                    "id": "item_24964_1760237402550_fcthj994m"
                }
            ],
            "513,500": [],
            "512,500": [
                {
                    "item": "circuit",
                    "progress": 0.8237166732988483,
                    "id": "item_24896_1760237400624_u7d0cvdue"
                }
            ],
            "511,500": [
                {
                    "item": "circuit",
                    "progress": 0.7879029048945506,
                    "id": "item_24899_1760237400732_1gcvhaokm"
                },
                {
                    "item": "circuit",
                    "progress": 0.39395145244727553,
                    "id": "item_24932_1760237401649_hiq9vy1qa"
                }
            ],
            "510,500": [
                {
                    "item": "circuit",
                    "progress": 0.2506963788300846,
                    "id": "item_24944_1217"
                }
            ],
            "519,511": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_0om3hemde"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_9ywyqz1dw"
                }
            ],
            "519,512": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_xg54o00rn"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_isrc9wajk"
                }
            ],
            "519,513": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_rl7ebxbqy"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_4t0n6l8e6"
                }
            ],
            "519,514": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_9mwkt2yrh"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_qalonbd4s"
                }
            ],
            "519,515": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_zy2ol4p0l"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_giddnb37w"
                }
            ],
            "519,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_xkbwj2e6f"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_22956_1760146649412_k7y1oaavw"
                }
            ],
            "520,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_vm4q8tol3"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_m8jykawcy"
                }
            ],
            "521,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_ofziv74jd"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_o9yh7ofmh"
                }
            ],
            "522,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_vvl61ft8a"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_20euwbqcf"
                }
            ],
            "523,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_n79rso1yh"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_l31zs5w49"
                }
            ],
            "524,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_gta6ewp35"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_598rdlowh"
                }
            ],
            "525,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_p03rop3wd"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_cpjudkt6u"
                }
            ],
            "526,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_5ygynekew"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_aldk45na5"
                }
            ],
            "527,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_82oqz3uut"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_xkf1i18gk"
                }
            ],
            "528,516": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_uf161vna8"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_ca231m7an"
                }
            ],
            "528,517": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_olbjxb6gi"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_16594_1760147990658_9wjewvvoi"
                }
            ],
            "528,519": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_u5v2p9a2u"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_gxaoaur8z"
                }
            ],
            "527,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_xekrak25p"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_vl76rocvc"
                }
            ],
            "526,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_h4uxklcoa"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_ohjem3mhf"
                }
            ],
            "525,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_coc5coixe"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_cl6nrojuu"
                }
            ],
            "524,519": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_33_1760148029474_4z0e6s4ud"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_33_1760148029474_oi24ou6sz"
                }
            ],
            "523,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_zvbqd58pl"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_kjocg34sk"
                }
            ],
            "522,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_1o8sxware"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_iajhfhk45"
                }
            ],
            "521,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_xty9ly4bo"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_m9ow8nh8g"
                }
            ],
            "520,519": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_18374_1760148027292_cwaqmubpv"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_18374_1760148027292_fauadpc98"
                }
            ],
            "519,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_s9y1hoi0q"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_iaobrs4sc"
                }
            ],
            "518,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_k5j32xiwk"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_hbk7rq33o"
                }
            ],
            "517,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_mv0op4x5d"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_20xz6xpmf"
                }
            ],
            "516,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_aonlc61nv"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_93_1760148030718_8pf744h6j"
                }
            ],
            "515,519": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24325_1760237385205_kyvhlh3ho"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24327_1760237385251_ua7lncnr2"
                }
            ],
            "514,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24326_1760237385227_xqrzyydhp"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24328_1760237385273_0p2or6hmm"
                }
            ],
            "513,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_121_1760148031307_hiztor2bn"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24297_1760237384160_extvohozj"
                }
            ],
            "512,518": [
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_121_1760148031307_0opc70y51"
                },
                {
                    "item": "sand",
                    "progress": 0.99,
                    "id": "item_24297_1760237384160_3i4e790jt"
                }
            ],
            "502,502": [
                {
                    "item": "iron-plate",
                    "progress": 0.99,
                    "id": "item_24652_1193"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.7282132908873877,
                    "id": "item_24904_1215"
                }
            ],
            "517,510": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12496_1760147897918_zg17swo9g"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12556_1760147899542_3ovnr3lqq"
                }
            ],
            "516,510": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12584_1760147900271_8jbn96chp"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12644_1760147901711_g0gw6812r"
                }
            ],
            "515,510": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12672_1760147902433_cple4g8vh"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12732_1760147903602_9w0get1u4"
                }
            ],
            "514,510": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12760_1760147904139_o3xs3nuvj"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12820_1760147905377_858gqojir"
                }
            ],
            "513,510": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12848_1760147905976_klopp6kc8"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12908_1760147907209_5o9tamtuu"
                }
            ],
            "513,511": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12936_1760147907794_sk25snl74"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_12996_1760147909018_12dz6tqvn"
                }
            ],
            "513,512": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13024_1760147909604_xmy8cwedf"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13084_1760147910859_s9s8szxk1"
                }
            ],
            "513,513": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13112_1760147911466_55wzw6vgi"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13172_1760147912737_44vzr2fa6"
                }
            ],
            "513,514": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13200_1760147913334_e8xru28sp"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13260_1760147914630_63qrn0wih"
                }
            ],
            "512,514": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13288_1760147915353_0lkka657d"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13348_1760147916755_423k98xep"
                }
            ],
            "511,514": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13376_1760147917331_28tcdbqpj"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13436_1760147918630_n93jpeja8"
                }
            ],
            "510,514": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13464_1760147919334_p6uu30099"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13524_1760147920784_o4axbzmcx"
                }
            ],
            "510,513": [
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13553_1760147921531_1cko4wy21"
                },
                {
                    "item": "gear",
                    "progress": 0.99,
                    "id": "item_13613_1760147923119_s2hvad5dd"
                }
            ],
            "492,499": [
                {
                    "item": "iron-ore",
                    "progress": 0.1671309192200564,
                    "id": "item_24952_1760237402251_h6dnrfr9o"
                },
                {
                    "item": "iron-ore",
                    "progress": 0.04775169120573039,
                    "id": "item_24962_1760237402509_amz99yex6"
                }
            ],
            "494,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.9789096697174718,
                    "id": "item_24883_1760237400186_ralq5esl9"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.3461997612415452,
                    "id": "item_24936_1760237401788_d6k63ggnu"
                }
            ],
            "493,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.9789096697174718,
                    "id": "item_24883_1760237400186_fyla2m04o"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.3461997612415452,
                    "id": "item_24936_1760237401788_ftutjdd0k"
                }
            ],
            "492,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.9789096697174718,
                    "id": "item_24883_1760237400186_qg9lrmpaa"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402541_ux3zoy097"
                }
            ],
            "491,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.9430959013131741,
                    "id": "item_24886_1760237400275_27vo3rcj3"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402541_sac9jfuwz"
                }
            ],
            "490,495": [
                {
                    "item": "iron-plate",
                    "progress": 0.48945483485873614,
                    "id": "item_24924_1760237401397_td9klyxa3"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402541_lgelyejr7"
                }
            ],
            "490,494": [
                {
                    "item": "iron-plate",
                    "progress": 0.48945483485873614,
                    "id": "item_24924_1760237401397_uqwpa8j02"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402541_s6k64qsoi"
                }
            ],
            "489,494": [
                {
                    "item": "iron-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1212"
                }
            ],
            "490,493": [
                {
                    "item": "iron-plate",
                    "progress": 0.023875845602865195,
                    "id": "item_24963_1760237402541_ybdnin441"
                }
            ],
            "490,492": [
                {
                    "item": "iron-plate",
                    "progress": 0.6327099084759271,
                    "id": "item_24912_1760237401098_d8l4afyne"
                }
            ],
            "490,491": [
                {
                    "item": "iron-plate",
                    "progress": 0.48945483485873614,
                    "id": "item_24924_1760237401397_smy3psg04"
                },
                {
                    "item": "iron-plate",
                    "progress": 0.20294468762435422,
                    "id": "item_24948_1760237402145_unqd35yuw"
                }
            ],
            "490,490": [
                {
                    "item": "iron-plate",
                    "progress": 0.05968961400716299,
                    "id": "item_24960_1760237402491_31aphgurw"
                }
            ],
            "489,490": [
                {
                    "item": "iron-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1213"
                }
            ],
            "490,489": [],
            "490,488": [
                {
                    "item": "iron-plate",
                    "progress": 0.6327099084759271,
                    "id": "item_24912_1760237401098_4vgjqr5f2"
                }
            ],
            "490,487": [
                {
                    "item": "iron-plate",
                    "progress": 0.20294468762435422,
                    "id": "item_24948_1760237402145_spal6vat5"
                }
            ],
            "490,486": [],
            "489,486": [
                {
                    "item": "iron-plate",
                    "progress": 0.775964982093118,
                    "id": "item_24900_1214"
                }
            ],
            "515,524": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_17962_1760148018101_rjbeu6qrm"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_17963_1760148018121_qjpw2hux9"
                }
            ],
            "515,523": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_17962_1269"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_17963_1270"
                }
            ],
            "520,524": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18067_1760148020391_wiv0vkmmc"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18068_1760148020413_jcfi0iz3y"
                }
            ],
            "520,523": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18067_1282"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18068_1283"
                }
            ],
            "524,524": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18160_1760148022740_gfmyur5lb"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18161_1760148022763_jlaf1l7o7"
                }
            ],
            "524,523": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18160_1296"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18161_1299"
                }
            ],
            "528,524": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18219_1760148023986_cw103u16x"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18220_1760148024008_kz1rszl9g"
                }
            ],
            "528,523": [
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18219_1306"
                },
                {
                    "item": "transistor",
                    "progress": 0.99,
                    "id": "item_18220_1307"
                }
            ]
        },
        "assemblerInventoryLayer": {
            "500,502": {
                "items": {
                    "iron-ore": 4,
                    "copper-ore": 0,
                    "iron-plate": 3,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "iron-plate",
                    "name": "Iron Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5120249701551944,
                "craftingStartTick": 24965
            },
            "500,515": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "iron-plate",
                    "name": "Iron Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            },
            "504,509": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 1,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "gear",
                    "name": "Gear",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-plate",
                            "count": 2
                        }
                    ],
                    "outputs": [
                        {
                            "item": "gear",
                            "count": 1
                        }
                    ],
                    "craftingTime": 0.5
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            },
            "508,495": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 4,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "copper-plate",
                    "name": "Copper Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "copper-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "copper-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5539942300039808,
                "craftingStartTick": 24965
            },
            "514,495": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 4,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "copper-plate",
                    "name": "Copper Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "copper-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "copper-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5539942300039808,
                "craftingStartTick": 24965
            },
            "508,500": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 4,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "circuit",
                    "name": "Circuit",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "copper-plate",
                            "count": 1
                        },
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "circuit",
                            "count": 1
                        }
                    ],
                    "craftingTime": 0.5
                },
                "craftingProgress": 0.9132510943095935,
                "craftingStartTick": 24965
            },
            "515,521": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 12,
                    "transistor": 4,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "transistor",
                    "name": "Transistor",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "sand",
                            "count": 3
                        }
                    ],
                    "outputs": [
                        {
                            "item": "transistor",
                            "count": 1
                        }
                    ],
                    "craftingTime": 1.2
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            },
            "520,521": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 12,
                    "transistor": 4,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "transistor",
                    "name": "Transistor",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "sand",
                            "count": 3
                        }
                    ],
                    "outputs": [
                        {
                            "item": "transistor",
                            "count": 1
                        }
                    ],
                    "craftingTime": 1.2
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            },
            "487,494": {
                "items": {
                    "iron-ore": 4,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "iron-plate",
                    "name": "Iron Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5539942300039808,
                "craftingStartTick": 24965
            },
            "487,490": {
                "items": {
                    "iron-ore": 4,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "iron-plate",
                    "name": "Iron Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5539942300039808,
                "craftingStartTick": 24965
            },
            "487,486": {
                "items": {
                    "iron-ore": 4,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "iron-plate",
                    "name": "Iron Plate",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "iron-ore",
                            "count": 1
                        }
                    ],
                    "outputs": [
                        {
                            "item": "iron-plate",
                            "count": 1
                        }
                    ],
                    "craftingTime": 3.2
                },
                "craftingProgress": 0.5539942300039808,
                "craftingStartTick": 24965
            },
            "524,521": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 12,
                    "transistor": 4,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "transistor",
                    "name": "Transistor",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "sand",
                            "count": 3
                        }
                    ],
                    "outputs": [
                        {
                            "item": "transistor",
                            "count": 1
                        }
                    ],
                    "craftingTime": 1.2
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            },
            "528,521": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 12,
                    "transistor": 4,
                    "steel-chest": 0
                },
                "recipe": {
                    "id": "transistor",
                    "name": "Transistor",
                    "craftingBuilding": "assembler",
                    "inputs": [
                        {
                            "item": "sand",
                            "count": 3
                        }
                    ],
                    "outputs": [
                        {
                            "item": "transistor",
                            "count": 1
                        }
                    ],
                    "craftingTime": 1.2
                },
                "craftingProgress": 0,
                "craftingStartTick": null
            }
        },
        "chestInventoryLayer": {
            "510,512": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 81,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            },
            "502,506": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 400,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            },
            "491,499": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            },
            "493,502": {
                "items": {
                    "iron-ore": 221,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            },
            "511,507": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 400,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 0,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            },
            "515,504": {
                "items": {
                    "iron-ore": 0,
                    "copper-ore": 0,
                    "iron-plate": 0,
                    "copper-plate": 0,
                    "gear": 0,
                    "circuit": 182,
                    "advanced-circuit": 0,
                    "sand": 0,
                    "transistor": 0,
                    "steel-chest": 0
                }
            }
        },
        "rejectedItemsLayer": {
            "508,494": {
                "timestamp": 24965,
                "itemType": "copper-ore"
            },
            "514,494": {
                "timestamp": 24965,
                "itemType": "copper-ore"
            },
            "499,502": {
                "timestamp": 24965,
                "itemType": "iron-ore"
            },
            "499,515": {
                "timestamp": 24965,
                "itemType": "iron-plate"
            },
            "518,508": {
                "timestamp": 24965,
                "itemType": "iron-plate"
            },
            "519,510": {
                "timestamp": 24965,
                "itemType": "sand"
            },
            "486,494": {
                "timestamp": 24965,
                "itemType": "iron-ore"
            },
            "486,490": {
                "timestamp": 24965,
                "itemType": "iron-ore"
            },
            "486,486": {
                "timestamp": 24965,
                "itemType": "iron-ore"
            },
            "511,507": {
                "timestamp": 24965,
                "itemType": "iron-plate"
            },
            "518,510": {
                "timestamp": 24965,
                "itemType": "gear"
            },
            "518,509": {
                "timestamp": 24965,
                "itemType": "gear"
            },
            "502,506": {
                "timestamp": 24965,
                "itemType": "iron-plate"
            },
            "520,520": {
                "timestamp": 24965,
                "itemType": "sand"
            },
            "524,520": {
                "timestamp": 24965,
                "itemType": "sand"
            },
            "507,500": {
                "timestamp": 24948,
                "itemType": "iron-plate"
            },
            "528,520": {
                "timestamp": 24965,
                "itemType": "sand"
            },
            "515,520": {
                "timestamp": 24965,
                "itemType": "sand"
            }
        },
        "minerTimerLayer": {
            "491,502": 2161,
            "511,491": 1,
            "495,486": 841,
            "487,499": 2161,
            "512,517": 241,
            "516,517": 1,
            "515,517": 1,
            "514,517": 241,
            "513,517": 241
        },
        "minerOutputBufferLayer": {},
        "prestigePoints": 0,
        "prestigeCount": 0,
        "cameraPos": {
            "x": 497,
            "y": 501
        },
        "currentBiome": "Plains",
        "playerFacing": "up",
        "zoomLevel": 2.75,
        "buildMenuOpen": false,
        "selectedCategory": null,
        "selectedBuilding": null,
        "helpMenuOpen": false,
        "saveMenuOpen": true,
        "leftPanelOpen": false,
        "debugMenuOpen": true,
        "achievementMenuOpen": false,
        "researchMenuOpen": false,
        "hasEnabledDebug": false,
        "achievements": {
            "first_game": {
                "unlocked": true,
                "unlockedAt": 1760105392388
            },
            "first_miner": {
                "unlocked": false,
                "unlockedAt": 1726154925000
            },
            "first_research": {
                "unlocked": true,
                "unlockedAt": 1760138189403
            }
        },
        "unlockedResearch": [
            "fast-logistics",
            "iron-storage",
            "assembler-optimization",
            "belt-stacking",
            "miner-optimization",
            "basic-circuits",
            "sand-dredging",
            "advanced-factories",
            "advanced-mining-drill",
            "output-buffering",
            "transistor-fabrication"
        ],
        "selectedResearch": "assembler-optimization",
        "researchProgress": {
            "output-buffering": {
                "circuit": 16,
                "gear": 2
            },
            "solar-infrastructure": {
                "circuit": 4
            },
            "advanced-circuits": {
                "circuit": 2
            },
            "miner-optimization": {
                "gear": 76
            },
            "assembler-optimization": {
                "circuit": 14
            }
        },
        "powerProduction": 360,
        "powerDemand": 502.59999999999803,
        "powerSatisfaction": 0.7162753680859558,
        "powerHistory": [
            {
                "tick": 24296,
                "production": 360,
                "demand": 385.59999999999826,
                "satisfaction": 0.9336099585062283
            },
            {
                "tick": 24416,
                "production": 360,
                "demand": 502.59999999999803,
                "satisfaction": 0.7162753680859558
            },
            {
                "tick": 24536,
                "production": 360,
                "demand": 502.59999999999803,
                "satisfaction": 0.7162753680859558
            },
            {
                "tick": 24656,
                "production": 360,
                "demand": 502.59999999999803,
                "satisfaction": 0.7162753680859558
            },
            {
                "tick": 24776,
                "production": 360,
                "demand": 502.59999999999803,
                "satisfaction": 0.7162753680859558
            },
            {
                "tick": 24896,
                "production": 360,
                "demand": 502.59999999999803,
                "satisfaction": 0.7162753680859558
            }
        ],
        "spaceGalaxyState": {
            "year": 4103,
            "globalStockpile": {
                "energy": 950,
                "alloys": 720,
                "research": 540,
                "food": 860,
                "credits": 640
            },
            "colonies": [
                {
                    "id": "sol",
                    "name": "Sol Assembly",
                    "focus": "logistics",
                    "population": 48,
                    "stability": 86,
                    "baseLogisticsCapacity": 36,
                    "buildings": {
                        "solar-array": 2,
                        "stellar-port": 1,
                        "habitat-ring": 1
                    }
                },
                {
                    "id": "eden",
                    "name": "New Eden",
                    "focus": "agriculture",
                    "population": 32,
                    "stability": 78,
                    "baseLogisticsCapacity": 26,
                    "buildings": {
                        "habitat-ring": 2,
                        "terraform-core": 1
                    }
                },
                {
                    "id": "kepler",
                    "name": "Kepler Research Union",
                    "focus": "science",
                    "population": 21,
                    "stability": 88,
                    "baseLogisticsCapacity": 22,
                    "buildings": {
                        "quantum-labs": 1,
                        "solar-array": 1
                    }
                },
                {
                    "id": "forge",
                    "name": "Vulcan Forgeworks",
                    "focus": "industry",
                    "population": 27,
                    "stability": 74,
                    "baseLogisticsCapacity": 28,
                    "buildings": {
                        "solar-array": 1
                    }
                }
            ],
            "upgrades": {
                "galactic-bureaucracy": false,
                "quantum-trade-network": false,
                "planetary-automation": false,
                "pan-galactic-forum": false,
                "stellar-cartography-ai": false,
                "harmonic-terraforming": false,
                "void-mercantile-charter": false
            },
            "tradeRoutes": [
                {
                    "id": "route-1",
                    "fromColonyId": "eden",
                    "toColonyId": "sol",
                    "resource": "food",
                    "capacity": 14,
                    "efficiency": 0.78
                },
                {
                    "id": "route-2",
                    "fromColonyId": "sol",
                    "toColonyId": "kepler",
                    "resource": "energy",
                    "capacity": 10,
                    "efficiency": 0.7
                },
                {
                    "id": "route-3",
                    "fromColonyId": "forge",
                    "toColonyId": "sol",
                    "resource": "alloys",
                    "capacity": 9,
                    "efficiency": 0.74
                }
            ],
            "logs": [
                "Prestige threshold met – civilization command uplink online.",
                "Colonies synced: Sol Assembly, New Eden, Kepler Research Union, Vulcan Forgeworks."
            ],
            "nextTradeRouteId": 4
        },
        "handCraftingQueue": [],
        "repeatableResearchLevels": {
            "assembler-optimization": 2,
            "belt-stacking": 1,
            "miner-optimization": 1,
            "output-buffering": 1
        },
        "prestigeUpgradeState": {
            "purchased": {},
            "selectedUpgrade": null
        }
    }
}`;

export const getDemoSave = (): string | null => DEMO_SAVE_STRING;

export const isDemoSlot = (slotIndex: number): boolean =>
  slotIndex === DEMO_SLOT_INDEX;

export const serializeDemoSave = (saveData: SaveData): string =>
  serializeSlotData(DEMO_SLOT_NAME, saveData);
